<template>
  <div class="feeCard">
    <div
      :key="index"
      class="cardItem"
      v-for="(item,index) in listData.list"
    >
      <div class="indexLabel c-999 flexBox h-center c-333">
        {{ index + 1 }}
      </div>
      <div class="subjectBox flexBox between">
        <div class="subjectInfo">
          <div class="classTitle c-333">
            {{ item.shopName }}
          </div>
        </div>
        <div class="price c-333">
          ￥{{ item.payablePrice / 100 }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive,watch } from 'vue'
export default {
    name: 'ServiceFeeCard',
    props:{
        list:Array,
       
    },
    setup(props){
        const listData = reactive({
            list:[],
           
        })
        watch(
            () => props.list,
            (newVal, oldVal) => {
                console.log(newVal)
                listData.list = newVal
            }
        )
        
        return { listData };
    }
}
</script>
<style lang="scss" scoped>
    .cardItem{
        background: #FFFFFF;
        border-radius: 10px;    
        display: flex;  
        margin-bottom:30px;
        position: relative;
        .indexLabel{
            min-width: 40px;
            background: #EEEEEE;
            border-radius: 10px 0px 0px 10px;
            font-size: 28px;
        }
        .subjectBox{
            flex:1;
            padding:24px 20px;
            font-size:28px;
            color:#3333;
            .subjectInfo{
                .classTitle{
                    line-height: 40px; 
                    
                }
                .time{
                    font-size: 24px;
                    margin-top: 20px;
                    line-height: 33px;
                }
            }
        }
         .yigoumai{
            position:absolute;
            right:0;
            top:0;
            width:82px;
        }
    }
    .flexBox{
        display: flex;
        align-items: center;
    }
    .h-center{
        text-align: center;
        justify-content: center;
    }
    .between{
        justify-content: space-between;
    }
    .c-333{
        color:#333
    }
    .c-666{
        color: #666666;
    }
</style>